import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycReviewSubmittedProps = EventProps

/**
 * @event onboarding_kyc_review_submitted
 * @description Emitted when the user completes the FrankieOne KYC review screen and the verification process begins.
 */
export const OnboardingKycReviewSubmittedAnalytics = createAnalyticsStatic<OnboardingKycReviewSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_REVIEW_SUBMITTED,
)

export default OnboardingKycReviewSubmittedAnalytics
